module.exports = "<div data-dojo-attach-point=\"focusNode\" tabindex=\"0\" data-focus=\"temporary\"></div>\n"